<template>
  <b-alert
    variant="success"
    v-model="show"
    dismissible
    fade
    @dismissed="changeValue"
  >
    {{ message }}
  </b-alert>
</template>

<script>
export default {
  name: "SuccessAlert",
  props: {
    message: {
      type: String
    },
    show: {
      type: Boolean
    }
  },
  methods: {
    changeValue() {
      this.$emit("hide-alert");
    }
  }
};
</script>
